import { Request } from '../../../httpClient/serverApi/requests/Request';
import { IGetItemsParams } from '../../../httpClient/serverApi/types/IGetItemsParams';
import { IGetItemsResult } from '../../../httpClient/serverApi/types/IGetItemsResult';
import { ISiteNameWithId } from '../types/ISiteNameWithId';

export interface IGetSiteNamesResult extends IGetItemsResult {
  siteNames: ISiteNameWithId[];
}

export class GetSiteNamesRequest extends Request<IGetItemsParams, IGetSiteNamesResult> {
  constructor(params: IGetItemsParams) {
    super('getSiteNames', params);
  }
}
